export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";